module.exports = __webpack_public_path__ + "static/media/DqEveryChildOfflineWorksheets.a5cc6ff8.jpg";